import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import detectOutsideClick from '../utils/detectOutsideClick';
import toggleBodyScrolling from '../utils/toggleBodyScrolling';

export default function OverlayComponent({ isOpen, closeCallback, children }) {
  const contentContainer = useRef(null);
  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
    } else {
      toggleBodyScrolling(isOpen);
    }

    if (isOpen) {
      //We need the timeout so our initial Click won't close the component, so
      //we take animation duration before we add the listener
      setTimeout(() => {
        window.addEventListener('click', handleClick);
        window.addEventListener('keydown', checkForEscape);
      }, 300);
    } else {
      window.removeEventListener('click', handleClick);
      window.removeEventListener('keydown', checkForEscape);
    }
    return () => {
      window.removeEventListener('click', handleClick);
      window.removeEventListener('keydown', checkForEscape);
    };
  }, [isOpen]);

  function handleClick(e) {
    if (!contentContainer?.current) return;

    detectOutsideClick(e, contentContainer, closeCallback);
  }

  function checkForEscape(e) {
    if (e.key === 'Escape') {
      closeCallback();
    }
  }

  return (
    <div
      className={clsx(
        'fixed top-0 left-0 z-50 transition-all w-screen h-screen',
        isOpen ? 'translate-x-0 opacity-100' : 'translate-x-full pointer-events-none opacity-0'
      )}
    >
      <div className="relative w-full h-full">
        <div className="absolute w-screen h-screen transition-opacity bg-black/60"></div>
        <div
          className="absolute right-0 w-10/12 h-screen max-h-screen bg-white drop-shadow-sm-white lg:w-5/12"
          ref={contentContainer}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
